<div class="submission-history m-t-10" *ngIf="submissionHistoryGrid">
  <div class="row align-items-center p-b-16">
    <div class="col-sm-12 col-lg-6">
      <div class="d-flex align-items-center flexmob">
        <!--<div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
          <i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview
        </div>-->
        <!--<div class="m-l-10 d-flex align-items-center">-->
        <div class="d-flex align-items-center">

          <!--<div class="m-l-10">-->
          <div class="">
            <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
              Submission History
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-lg-6  text-right"></div>
  </div>

  <mat-card class="m-t-10" style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-16">
      <div class="row">
        <div class="col-md-6">

        </div>
        <div class="col-md-6 text-right">
          <mat-form-field appearance="outline" class="hide-hint bg-white" style="border-radius: 10px;">
            <input style="height: 30px;" matInput type="search" (input)="applyFilter($event)" placeholder="Search Submissions..." />
            <mat-icon matSuffix>
              <i-tabler name="search" class="icon-20 m-0" style="line-height: 15px !important"></i-tabler>
            </mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="table-responsive rounded-3 m-y-16 table-container1">

        <table mat-table [dataSource]="dataSource" class="w-100">
          <ng-container matColumnDef="Date" matSort>
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="f-w-600 f-s-14">Date</th>
            <td mat-cell *matCellDef="let submissions">{{ submissions.date | date:"yyyy-MM-dd'T'HH:mm:ss" }}</td>
          </ng-container>
          <ng-container matColumnDef="CharityName">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 charity-column">Charity Name</th>
            <td mat-cell *matCellDef="let submissions" class="charity-column">{{ getName(submissions.CharityName) }}</td>
          </ng-container>
          <ng-container matColumnDef="SubmissionType">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14" style="white-space:nowrap">Submission Type</th>
            <td mat-cell *matCellDef="let submissions">{{ submissions.SubmissionType }}</td>
          </ng-container>
          <ng-container matColumnDef="Accounting Period">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 ">Accounting Period</th>
            <td mat-cell *matCellDef="let submissions">{{ submissions.AccountingPeriod }}</td>
          </ng-container>
          <ng-container matColumnDef="Reference">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14" style="white-space:nowrap">Submission Number</th>
            <td mat-cell *matCellDef="let submissions">{{ submissions.Reference }}</td>
          </ng-container>

          <ng-container matColumnDef="TransactionNumber">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Transaction Number</th>
            <td mat-cell *matCellDef="let submissions">{{ submissions.TransactionNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Status</th>
            <td mat-cell *matCellDef="let submissions">
              <span *ngIf="submissions.Status!='Failed'" class="text-success rounded f-w-600 p-6 p-y-4 f-s-12">{{ submissions.Status| titlecase }}</span>
              <span *ngIf="submissions.Status=='Failed'" class="bg-outline-failed text-failed rounded f-w-600 p-6 p-y-4 f-s-12">{{ submissions.Status | titlecase}}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="example-first-header-row"
              style=" background: #107972 !important; color: #fff !important"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor:pointer" (click)="showCharitySubmission(row.CharityId)"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center " [attr.colspan]="displayedColumns.length">
              <div class="container-fluid bg-light-primary rounded p-20 f-s-14">
                No records found
              </div>
            </td>
          </tr>

        </table>

      </div>
      <div [ngClass]="((dataSource.data.length>0 && !dataSource.filter )||(dataSource.filter && dataSource.filteredData.length > 0) ) ? '' : 'd-none'">
        <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                       showFirstLastButtons>
        </mat-paginator>
      </div>


    </mat-card-content>
  </mat-card>

</div>



<div class="submission-status" *ngIf="submissionStatus">
  <div class="row align-items-center m-t--10">
    <div class="col-sm-12 col-lg-6">
      <div class="d-flex align-items-center flexmob">
        <!--<div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
          <i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview
        </div>-->
        <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backTohistory()">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Submission History
        </div>
        <div class="m-l-10 d-flex align-items-center">

          <div class="m-l-10">
            <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
              Submission History
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-lg-6  text-right"></div>
  </div>

  <mat-card class="m-t-20">
    <mat-card-content class="p-0">
      <div class="col-12">
        <div class="row">
          <div class="col-md-3 p-0 b-r-1" style="height: auto;overflow-y: scroll;">
            <div class="h-cust-submissions">
              <div class="text-center p-16 sticky-header" style="background: #10837b;">
                <span class="text-white f-w-600 f-16">Charities</span>
              </div>
              <div class="CharityData b-b-1" [ngClass]="(charity.charityId == Submissionsapiservice.currentcharityid) ? 'active' : ''" *ngFor="let charity of charities">
                <div (click)="showCharitySubmission(charity.charityId)">
                  <h6 class="f-w-600 p-10 p-b-2 m-0 f-s-14" style="word-break: break-all;">{{ charity.charityName }}</h6>
                  <p class="text-black p-x-10 f-s-14 m-t-0 m-b-10">Total Submissions: <span class="f-15 fw-bold text-black">{{ charity.submissionCount }}</span></p>
                </div>
              </div>
              <!--<div class="CharityData b-b-1">
                <div>
                  <h6 class="f-w-600 p-10 p-b-2 m-0 f-s-14">Hope Foundation</h6>
                  <p class="text-black p-x-10 f-s-14 m-t-0 m-b-10">Total Submissions: <span class="f-15 fw-bold text-black">{{ charity.totalSubmissions }}</span></p>
                </div>
              </div>-->
            </div>
          </div>
          <div class="col-md-9 p-16">
            <div class="row">
              <div class="col-md-6 col-sm-6">
                <mat-form-field appearance="outline" class="hide-hint bg-white" style="border-radius: 10px;">
                  <input style="height: 30px;" matInput (input)="applyCharitySearch($event)" type="search" placeholder="Search Submissions..." />
                  <mat-icon matSuffix>
                    <i-tabler name="search" class="icon-20 m-0" style="line-height: 15px !important"></i-tabler>
                  </mat-icon>
                </mat-form-field>
              </div>
              <div class="col-md-6 col-sm-6 text-right pt-10">
                <button mat-fab extended style="height: 40px;" class="filter-btn" (click)="filter(filterblock)">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-18 m-r-4" name="filter"></i-tabler><span *ngIf="filterblock" class="m-r-5">Hide</span> <span class="hidemenutext">Filter</span>
                  </div>
                </button>
              </div>
            </div>

            <mat-card *ngIf="filterblock" class="m-t-20" style="box-shadow: 0 2px 6px #dadada !important">
              <mat-card-content class="p-16">
                <div class="filter">

                  <div class="row" [formGroup]="CharityFilterForm">
                    <div class="col-lg-4">
                      <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Date</mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="date" placeholder="All Dates" (selectionChange)="selectionClear($event)">
                          <mat-option value="">All Dates</mat-option>
                          <mat-option value="today">Today</mat-option>
                          <mat-option value="thisWeek">This Week</mat-option>
                          <mat-option value="thisMonth">This Month</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-4">
                      <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Status</mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="status" value="Status" placeholder="All Status" (selectionChange)="selectionClear($event)">
                          <mat-option value="">All Status</mat-option>
                          <mat-option *ngFor="let data of uniqueStatusSet" value="{{data}}">{{ data | titlecase }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-4">
                      <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Accounting Period</mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="accountingPeriod" value="Status" placeholder="Select Accounting Period" (selectionChange)="selectionClear($event)">
                          <mat-option *ngFor="let data of charitySubmissions " value="{{data}}">{{data}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="text-right">
                    <button *ngIf="clearFilter" mat-flat-button class="bg-error text-white  m-r-10 " (click)="clearCharityfilter()">
                      Clear Filters
                    </button>
                    <button class="custombtn m-r-10" mat-flat-button (click)="applyCharityFilter()">
                      Apply
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <div class="table-responsive rounded-3 m-y-16 table-container1">

              <table mat-table [dataSource]="charitydataSource" class="w-100" style="max-height: 650px; overflow: auto;">
                <ng-container matColumnDef="Date">
                  <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Date</th>
                  <td mat-cell *matCellDef="let submissions2">{{ submissions2.date| date:"yyyy-MM-dd'T'HH:mm:ss" }}</td>
                </ng-container>

                <ng-container matColumnDef="Accounting Period">
                  <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Accounting Period</th>
                  <td mat-cell *matCellDef="let submissions2">{{ submissions2.accountingPeriod }}</td>
                </ng-container>

                <ng-container matColumnDef="CharityName">
                  <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Charity Name</th>
                  <td mat-cell *matCellDef="let submissions2">{{ submissions2.charityName }}</td>
                </ng-container>

                <ng-container matColumnDef="Reference">
                  <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Submission Number</th>
                  <td mat-cell *matCellDef="let submissions2">{{ submissions2.reference }}</td>
                </ng-container>

                <ng-container matColumnDef="TransactionNumber">
                  <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Transaction Number</th>
                  <td mat-cell *matCellDef="let submissions2">{{ submissions2.transactionNumber }}</td>
                </ng-container>

                <ng-container matColumnDef="SubmissionType">
                  <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Submission Type</th>
                  <td mat-cell *matCellDef="let submissions2">{{ submissions2.submissionType }}</td>
                </ng-container>

                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Status</th>
                  <td mat-cell *matCellDef="let submissions2">
                    <span *ngIf="submissions2.status=='Failed'" class="bg-outline-failed text-failed rounded f-w-600 p-6 p-y-4 f-s-12">{{ submissions2.status | titlecase }}</span>
                    <span *ngIf="submissions2.status!='Failed'" class="text-success rounded f-w-600 p-6 p-y-4 f-s-12">{{ submissions2.status | titlecase }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Action</th>
                  <td mat-cell *matCellDef="let submissions">
                    <button [matMenuTriggerFor]="menu" class="borderbtn b-0 bgwhite">
                      <i-tabler name="dots-vertical" class="icon-20"></i-tabler>
                    </button>
                    <mat-menu #menu="matMenu" class="dotnav p-0 m-t-10">
                      <button mat-menu-item class="m-0 d-flex align-items-center gap-10" [disabled]="submissions.status!='Failed'" (click)="openErrorLog(template,submissions.submissionId)">
                        <i-tabler name="file-alert" class="icon-20 m-r-10"></i-tabler>
                        <span class="" style="position:relative;top:-3px">Show Error</span>
                      </button>
                      <button mat-menu-item class="m-0 d-flex align-items-center gap-10" (click)="fbiReceiptDownload(modal,submissions.submissionId)">
                        <i-tabler name="printer" class="icon-20 m-r-10"></i-tabler>
                        <span class="" style="position:relative;top:-3px">Print FBI Receipt</span>
                      </button>
                      <button mat-menu-item class="m-0 d-flex align-items-center gap-10" (click)="fbiDownload(submissions.submissionId)" [disabled]="!UserRoleAccess?.m2ExportorDownload">
                        <i-tabler name="download" class="icon-20 m-r-10"></i-tabler>
                        <span class="" style="position:relative;top:-3px">Download FBI Receipt</span>
                      </button>
                      <button mat-menu-item class="m-0 d-flex align-items-center gap-10" (click)=" openXmlDialog(submissions.submissionId)">
                        <i-tabler name="file-type-xml" class="icon-20 m-r-10"></i-tabler>
                        <span class="" style="position:relative;top:-3px">View in XML </span>
                      </button>
                      <button mat-menu-item class="m-0 d-flex align-items-center gap-10" (click)="downloadZip(submissions.submissionId)" [disabled]="!UserRoleAccess?.m2ExportorDownload">
                        <i-tabler name="cloud-download" class="icon-20 m-r-10"></i-tabler>
                        <span class="" style="position:relative;top:-3px">Download in XML</span>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns2" class="example-first-header-row sticky-header" style=" background: #10837b !important; color: #fff !important;"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell text-center " [attr.colspan]="displayedColumns2.length">
                    <div class="container-fluid bg-light-primary rounded p-20 f-s-14">
                      No records found
                    </div>
                  </td>
                </tr>
              </table>
              <div [ngClass]="((charitydataSource.data.length>0 && !charitydataSource.filter )||(charitydataSource.filter && charitydataSource.filteredData.length > 0) ) ? '' : 'd-none'">
                <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                               showFirstLastButtons>
                </mat-paginator>
              </div>

            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

</div>

<ng-template #template>
  <mat-dialog-content class="f-s-14 lh-16 p-10">

    <div class="d-flex align-items-center justify-content-between p-b-16 m-b-20 b-b-1">
      <div class="p-t-4">
        <mat-label class="f-s-18 f-w-600 d-block m-b-8 heading">
          Error Log
        </mat-label>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-10">
        <button mat-flat-button color="primary" class="bg-success text-end" (click)="errorDownload(submissionId)">
          <div class="d-flex text-white">
            <i-tabler class="icon-18 m-r-4 text-white" name="download"></i-tabler><span class="f-s-14 text-white"> Download </span>
          </div>
        </button>
        <button mat-dialog-close class="text-center btn-close-dialog" style="transform:scale(0.8)">
          <i-tabler name="X" class=""></i-tabler>
        </button>
      </div>
    </div>

    <div>
      <p>Submission Errors</p>
      <div class="b-1 m-0" style="border-radius: 7px;">

        <div class="p-14" *ngFor="let data of errorList">
          <div class="row align-items-center m-b-12">
            <div class="col-md-4">
              <mat-label class="f-s-14 f-w-600 m-b-8" style="color: #10837b;">
                Error Location
              </mat-label>
            </div>
            <div class="col-md-8">
              <mat-label class="f-s-14 f-w-400 m-b-8">
                <div class="row subRes">
                  <div class="col-sm-1">
                    <span class="m-r-14">:</span>
                  </div>
                  <div class="col-md-11">
                    <span class="error-text"> {{data.errorLocation}}</span>
                  </div>
                </div>

              </mat-label>
            </div>
          </div>
          <div class="row align-items-center m-b-12">
            <div class="col-md-4">
              <mat-label class="f-s-14 f-w-600 m-b-8" style="color: #10837b;">
                Error Number
              </mat-label>
            </div>
            <div class="col-md-8">
              <mat-label class="f-s-14 f-w-400 m-b-8">
                <div class="row subRes">
                  <div class="col-sm-1">
                    <span class="m-r-14">:</span>
                  </div>
                  <div class="col-md-11">
                    <span class="error-text">{{data.errorNumber}}</span>
                  </div>
                </div>

              </mat-label>
            </div>
          </div>
          <div class="row align-items-center m-b-12">
            <div class="col-md-4">
              <mat-label class="f-s-14 f-w-600 m-b-8" style="color: #10837b;">
                Error Type
              </mat-label>
            </div>
            <div class="col-md-8">
              <mat-label class="f-s-14 f-w-400 m-b-8">
                <div class="row subRes">
                  <div class="col-sm-1">
                    <span class="m-r-14">:</span>
                  </div>
                  <div class="col-md-11">
                    <span class="error-text"> {{data.errorType}}</span>
                  </div>
                </div>

              </mat-label>
            </div>
          </div>
          <div class="row m-b-12">
            <div class="col-md-4">
              <mat-label class="f-s-14 f-w-600 m-b-8" style="color: #10837b;">
                Error Text
              </mat-label>
            </div>
            <div class="col-md-8">
              <mat-label class="f-s-14 f-w-400 m-b-8 ">
                <div class="row subRes">
                  <div class="col-sm-1">
                    <span class="m-r-14">:</span>
                  </div>
                  <div class="col-md-11">
                    <span class="error-text">{{data.errorText}}</span>
                  </div>
                </div>

              </mat-label>
            </div>
          </div>
        </div>
      </div>
    </div>

  </mat-dialog-content>
</ng-template>

<ng-template #xmlViewerTemplate>
  <mat-dialog-content class="f-s-14 lh-16 p-10" style="overflow: hidden;">

    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between p-b-16 m-b-20 b-b-1">
      <div class="p-t-4">
        <mat-label class="f-s-18 f-w-600 d-block m-b-8 heading">
          XML Data Viewer
        </mat-label>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-10">
        <button mat-flat-button color="primary" class="bg-success text-end" (click)="downloadZip(0,true)">
          <div class="d-flex text-white">
            <i-tabler class="icon-18 m-r-4 text-white" name="download"></i-tabler>
            <span class="f-s-14 text-white">Download</span>
          </div>
        </button>
        <button mat-dialog-close class="text-center btn-close-dialog" style="transform:scale(0.8)">
          <i-tabler name="X"></i-tabler>
        </button>
      </div>
    </div>

    <!-- XML Content -->
    <div class="b-1" style="border-radius: 7px;">
      <div class="p-14">
        <!--<mat-label class="f-s-14 f-w-600 m-b-8 d-block" style="color: #10837b;">
          XML Content
        </mat-label>-->

        <div class="xml-viewer">
          <ace [mode]="mode"
               [theme]="theme"
               [options]="editorOptions"
               [value]="xmlDataRequest"
               [disabled]="true"
               style="height: 500px; width: 100%; border: 1px solid #ccc;"></ace>
        </div>

        <!--<ace-editor [(text)]="code"
              [mode]="mode"
              [theme]="theme"
              [options]="{ fontSize: '14px', showPrintMargin: false }"
              (textChanged)="onCodeChange($event.text)"
              style="min-height: 400px; width: 100%; border: 1px solid #ccc;"></ace-editor>-->
        <!-- Scrollable pretty XML -->
        <!--<pre class="xml-container">
          {{ xmlDataRequest }}
        </pre>-->

      </div>
    </div>



  </mat-dialog-content>
</ng-template>
<ng-template #modal>
  <mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="p-20">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>File by Internet Receipt</span></b>
          <button class="btn-close-dialog" mat-dialog-close>
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;">
        <div class="col-lg-12" style="height:750px;">
          <ng2-pdfjs-viewer #pdfViewerAutoLoad></ng2-pdfjs-viewer>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>

<div class="spinner-container" *ngIf="this.loadspinner">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</div>
